import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, Activity, ActivityResponse, User, ProjectResponse, Project, UserInfo } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { BusyProvider } from '../service/busy.service';
import { ReportService } from '../service/report.service';
import { ActivityService } from '../service/activity.service';
import { UserService } from '../service/user.service';
import { TaskService } from '../service/task.service';
import { PresenzeService } from '../service/presenze.service';
import { GlobalFilterService } from '../service/global-filter.service';
import { AppConstants } from '../core/app.constants';
import { SelectItem } from 'primeng/primeng';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { DatePipe } from '@angular/common';

declare var $: any;
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-activities',
    templateUrl: './activities.component.html',
    styleUrls: ['./activities.component.css'],
})
export class ActivitiesComponent extends BaseComponent implements OnInit, OnDestroy {
    static REPORT_DIALOG_ID: string = "detailReportDialogID";

    @Input() refresh: Subject<boolean>;
    @Input() isFullSize: boolean = false;

    it: any = AppConstants.ITA_CALENDAR_CONF;
    activities: Activity[] = new Array();
    userContext: UserContext;
    users: User[] = [];
    userInfo: UserInfo;
    usersSelected: SelectItem[] = [];
    filterUsers: SelectItem[] = [];
    selectedGruppo: number = 0;
    gruppiUsers: SelectItem[] = [];
    gruppi: SelectItem[]=[];
    
    numgruppi: number = null;
    utentiVisibili: SelectItem[]=[];
    filteredUsers: SelectItem[] = [];
    filterUsernames: SelectItem[] = [];
    managedUsers: SelectItem[] = [];
    inactiveUsers = [];
    projects: SelectItem[] = []; // ad uso del filtro per task
    forceReloadFilterTask = false;
    tasksFiltered: SelectItem[] = [];
    tasksSelected: SelectItem[] = [];
    completed: boolean = false;
    showFilter: boolean = false;
    fromDate: Date = null;
    toDate: Date = null;
    showDeleteAlert: boolean = false;
    currentActivity: Activity = null;
    totalTime: string = null;
    @Output() fullSize = new EventEmitter<boolean>();
    @Output() onDelete = new EventEmitter<boolean>();
    @Output() enableOpenDetail = new EventEmitter<boolean>();
    canUpdate: boolean = true;
    sortField: string = null;
    sortAsc: boolean = false;
    globalFilterSubscription: Subscription = null;
    filterTaskSubscription: Subscription = null;
    showUserColumn = false;

    reportFromDate: Date = null;
    reportToDate: Date = null;
    reportDetailed: boolean = false;
    acceptTermOfUse: boolean = false;

    usersGroupFilter = false;

    constructor(protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider,
        private activityService: ActivityService,
        private userService: UserService,
        private taskService: TaskService,
        private filterService: GlobalFilterService,
        private reportService: ReportService,
        private busyProvider: BusyProvider,
        private datePipe: DatePipe,
        private presenzeService: PresenzeService) {
        super(authAccess, router, messageProvider);
    }

    ngOnDestroy() {
        if (this.globalFilterSubscription != null) {
            this.globalFilterSubscription.unsubscribe();
        }
        if (this.filterTaskSubscription != null) {
            this.filterTaskSubscription.unsubscribe();
        }
    }

    ngOnInit() {
        this.userContext = this.authAccess.getUserContext();
        if (this.userContext == null) {
            this.authAccess.invalidate();
        } else {
            this.fromDate = new Date();
            this.fromDate.setDate(1); // primo del mese
            this.toDate = new Date(); // data corrente

            this.reportFromDate = this.fromDate;
            this.reportToDate = this.toDate;

            this.refresh.asObservable().subscribe(value => { this.reload(); });
            this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
                result => {
                    this.userInfo = result;
                    if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
                        this.userInfo.managedUsers.push(this.userContext.userId);
                    }
                    this.initFilterUsers();
                    this.search(false);

                    if (this.userInfo.admin) {
                        this.fromDate = new Date();
                        this.toDate = new Date();
                        this.showUserColumn = true;
                        this.reload();
                    }
                    this.gruppi=[];
                    this.numgruppi=0;
                    this.gruppi.push({ label: "Tutti i gruppi", value: this.numgruppi });
                    for (const key in this.userInfo.managedUsersMap) {
                        this.numgruppi++;
                        this.gruppi.push({ label: key, value: this.numgruppi });
                        
                    }
                    

                },
                error => {
                    this.handleError(error);
                }
            );

            this.taskService.getUserProjects(this.userContext.srmToken).subscribe(
                response => {
                    let projectResponse: ProjectResponse = response;
                    for (let i = 0; i < projectResponse.userProjects.length; ++i) {
                        let project: Project = projectResponse.userProjects[i];
                        this.projects.push({ label: project.name, value: project.id });
                    }
                },
                error => {
                    this.handleError(error);
                }
            );

            this.globalFilterSubscription = this.filterService.getGlobalFilter().subscribe(
                filter => {
                    if (!filter) return;
                    this.fromDate = filter.dateFrom;
                    this.toDate = filter.dateTo;
                    if (this.userInfo && (this.userInfo.admin || this.userInfo.managedUsers.length > 0)) {
                        this.usersSelected = filter.users;
                        this.usersGroupFilter = filter.usersGroupFilter;
                        this.utentiVisibili=filter.users;
                    }
                    if (this.userInfo) this.reload();
                }
            );
        }
    }

    reload() {
        this.search(false);
    }

    toggleFilter() {
        this.showFilter = !this.showFilter;
    }

    applyFilter() {
        // this.usersGroupFilter = false;
        this.search(true);
    }

    setFullSize() {
        this.fullSize.emit(true);
        this.isFullSize = true;
    }

    resize() {
        this.fullSize.emit(false);
        this.isFullSize = false;
    }

    private search(switchFilter: boolean) {
        this.completed = false;
        this.activities = [];
        this.sortField = "";
        this.messageProvider.clearAll();
        this.canUpdate = this.usersSelected.length == 0;
        var response: ActivityResponse;
        let tasksId: number[] = [];
        for (let i = 0; i < this.tasksSelected.length; ++i) {
            tasksId.push(this.tasksSelected[i].value);
        }
        let usersId: number[] = [];
        for (let i = 0; i < this.utentiVisibili.length; ++i) {
            usersId.push(this.utentiVisibili[i].value);
        }
        if (usersId.length == 0) {
            this.activityService.search(this.userContext.srmToken, this.fromDate, this.toDate, null, tasksId).
                subscribe(
                    result => {
                        this.completed = true;
                        response = result;
                        this.activities = response.activities;
                        this.fillFullname(this.activities);
                        this.sort('date'); // sort crescente
                        this.sort('date'); // sort decrescente - default
                        if (switchFilter && this.activities.length != 0) {
                            this.toggleFilter();
                        }
                        this.totalTime = AppConstants.formatDuration(response.totalHours, response.totalMinutes);
                        this.showUserColumn = this.userInfo.admin || (this.userInfo.managedUsers.length > 0 && usersId.length > 0);
                    },
                    error => {
                        this.completed = true;
                        this.handleError(error);
                    });
        }
        else {
            let observables: Observable<any>[] = [];
            for (let i = 0; i < usersId.length; ++i) {
                let obs = this.activityService.search(this.userContext.srmToken, this.fromDate, this.toDate, usersId[i], tasksId);
                observables.push(obs);
            }
            Observable.forkJoin(observables).subscribe(
                results => {
                    this.completed = true;
                    let totH: number = 0
                    let totM: number = 0
                    for (let i = 0; i < results.length; ++i) {
                        let currentResponse: ActivityResponse = results[i];
                        this.activities = this.activities.concat(currentResponse.activities);
                        this.fillFullname(this.activities);
                        totH += currentResponse.totalHours;
                        totM += currentResponse.totalMinutes;
                    }
                    this.sort('user');
                    if (switchFilter && this.activities.length != 0) {
                        this.toggleFilter();
                    }
                    this.totalTime = AppConstants.formatDuration(totH, totM);
                    this.showUserColumn = this.userInfo.admin || (this.userInfo.managedUsers.length > 0 && usersId.length > 0);
                },
                error => {
                    this.completed = true;
                    this.handleError(error);
                });
        }
    }

    private fillFullname(activities: Activity[]) {
        for (let i = 0; i < activities.length; i++) {
            for (let j = 0; j < this.users.length; j++) {
                if (this.users[j].username.toLowerCase() == activities[i].username.toLowerCase()) {
                    activities[i].fullname = this.users[j].fullname;
                    break;
                }
            }
        }
    }

    sort(field: string) {
        if (field == this.sortField) {
            this.activities = this.activities.reverse();
            this.sortAsc = !this.sortAsc;
        } else {
            this.sortField = field;
            this.sortAsc = true;
            this.activities = this.activities.sort((a1, a2) => {
                if (this.sortField == "date") {
                    if (a1.inserted == a2.inserted) {
                        return a1.id > a2.id ? 1 : -1;
                    }
                    return a1.inserted > a2.inserted ? 1 : -1;
                }
                if (this.sortField == "task") {
                    if (a1.issueNo == a2.issueNo) {
                        if (a1.inserted == a2.inserted) {
                            return a1.fullname > a2.fullname ? 1 : -1;
                        }
                        return a1.inserted > a2.inserted ? -1 : 1;
                    }
                    return a1.issueNo > a2.issueNo ? 1 : -1;
                }
                if (this.sortField == "user") {
                    if (a1.fullname == a2.fullname) {
                        if (a1.inserted == a2.inserted) {
                            return a1.id > a2.id ? -1 : 1;
                        }
                        return a1.inserted > a2.inserted ? -1 : 1;
                    }
                    return a1.fullname > a2.fullname ? 1 : -1;
                }
                return 0;
            });
        }
    }

    applyUsersGroupFilter() {
        this.usersSelected = [];
        this.usersGroupFilter = !this.usersGroupFilter;
       
        if (this.usersGroupFilter) {
            
            for (let i = 0; i < this.filterUsers.length; i++) {
                
                if ((this.inactiveUsers.indexOf(this.filterUsers[i].value) == -1) && this.userInfo.managedUsers.some(user => this.filterUsers[i].label.toLowerCase().includes(user.toLowerCase()))){
                   this.usersSelected.push(this.filterUsers[i]);
                   
                }
                

            }
            
           if (this.gruppi.length==2)
                this.selectedGruppo=1;
            this.filterUtentiGruppi();
        }
        else
            this.utentiVisibili=[];
    }

    getGruppo(id: number): string | null {
        const gruppo = this.gruppi.find(userGroup => userGroup.value === id);
        if (gruppo) {
            return gruppo.label;
        }
        return null;
    }

    filterUser(event) {
        this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
    }

    private initFilterUsers() {
        if (!this.userInfo.admin && this.userInfo.managedUsers.length == 0) {
            return;
        }
        this.userService.getUsers(this.userContext.srmToken, false).
            subscribe(
                result => {
                    
                    this.users = result.users;
                    for (var i = 0; i < result.users.length; ++i) {
                        var current: User = result.users[i];
                        
                        if (this.userInfo.admin || this.userInfo.managedUsers.indexOf(current.username.toLowerCase()) != -1) {
                            this.filterUsers.push({ label: current.fullname, value: current.id });
                            this.gruppiUsers.push({ label: this.getGruppoUser(current), value: current.id});
                            this.filterUsernames.push({ label: current.username, value: current.id });
                            if (!current.active) {
                                this.inactiveUsers.push(current.id);
                            }
                        }
                    }
                    for (var i = 0; i < this.filterUsers.length; i++) {
                                
                            if (this.userInfo.managedUsers.some(user => this.filterUsernames[i].label.toLowerCase().includes(user.toLowerCase())))
                                this.managedUsers.push(this.filterUsers[i]);
                    }
                },
                error => {
                    this.handleError(error);
                });
    }

    filterTask(event) {
        this.tasksFiltered = [];
        this.tasksFiltered.push({ label: 'Caricamento in corso...', value: '' });
        var projectIds = '';
        this.projects.forEach(project => {
            projectIds += ',' + project.value;
        });
        projectIds = projectIds.substring(1);
        if (this.filterTaskSubscription != null) {
            this.filterTaskSubscription.unsubscribe();
        }
        this.filterTaskSubscription = this.taskService.searchTaskByProject(this.userContext.srmToken, event.query, projectIds, 20, this.forceReloadFilterTask).subscribe(
            result => {
                this.forceReloadFilterTask = false;
                this.tasksFiltered = [];
                result.issues.forEach(issue => {
                    this.tasksFiltered.push({ label: issue.issueNo + ' - ' + issue.title, value: issue.id });
                });
            }
        );
    }

    openDetail(activity: Activity) {
        this.enableOpenDetail.emit(false);
        const today = new Date();
        if (!activity && this.fromDate.getDate() <= today.getDate() && today.getDate() <= this.toDate.getDate()) {
            this.presenzeService.timeworked(this.userContext.srmToken, today, null).subscribe(
                timeworked => {
                    let diff = (timeworked.hoursValued + timeworked.minutesValued / 60);
                    this.activities.forEach(activity => {
                        if (this.datePipe.transform(activity.inserted, 'ddMMyyyy') == this.datePipe.transform(today, 'ddMMyyyy')) {
                            diff = diff - activity.spentHours - activity.spentMinutes / 60;
                        }
                    });
                    activity = new Activity();
                    activity.spentHours = Math.floor(diff);
                    activity.spentMinutes = (diff - activity.spentHours) * 60;
                    this.activityService.openActivityDetail(activity);
                });
        } else {
            if (activity == null) {
                activity = new Activity();
            }
            this.activityService.openActivityDetail(activity);
        }
    }

    cloneActivityFromList(activity: Activity) {
        this.enableOpenDetail.emit(false);
        let clonedActivity = new Activity();
        clonedActivity.activityTypeId = activity.activityTypeId;
        clonedActivity.issueId = activity.issueId;
        this.activityService.openActivityDetail(clonedActivity);
    }

    deleteActivity() {
        this.messageProvider.clearAll();
        if (this.currentActivity == null) {
            // non dovrebbe mai verificarsi
            alert("Nessuna attività da eliminare!");
            return;
        }
        this.activityService.deleteActivity(this.userContext.srmToken, this.currentActivity.id, this.currentActivity.issueId).
            subscribe(
                result => {
                    this.messageProvider.notifyMessage("Attività eliminata correttamente");
                    this.currentActivity = null;
                    this.onDelete.emit(true);
                },
                error => {
                    this.handleError(error);
                });
    }

    openDeleteAlert(currentActivity) {
        this.currentActivity = currentActivity;
        this.showDeleteAlert = true;
    }
    
    closeDeleteAlert() {
        this.showDeleteAlert = false;
    }

    openTaskDialog() {
        this.taskService.openTaskDetail();
    }

    openReportDialog() {
        this.acceptTermOfUse = false;
        $("#" + ActivitiesComponent.REPORT_DIALOG_ID).modal({ backdrop: 'static', keyboard: false });
    }

    closeReportDialog() {
        $("#" + ActivitiesComponent.REPORT_DIALOG_ID).modal("hide");
    }

    exportReport() {
        this.closeReportDialog();
        this.busyProvider.showBusyIndicator();
        this.messageProvider.clearAll();
        var from = this.datePipe.transform(this.reportFromDate, 'yyyy-MM-dd');
        var to = this.datePipe.transform(this.reportToDate, 'yyyy-MM-dd');

        // report attività raggruppate per task
        if (this.reportDetailed == false) {
            const reportClass = 'com.netsitech.srm.excel.generator.ActivitiesByOfficetReportGenerator';
            const parameters = new Object();
            parameters['from'] = from;
            parameters['to'] = to;
            parameters['currentUser'] = true;

            var userProjects = [];
            for (var i = 0; i < this.projects.length; i++) {
                userProjects.push(this.projects[i].value);
            }
            parameters['projects'] = userProjects;

            this.reportService.exportReport(this.userContext.srmToken, reportClass, parameters).
                subscribe(
                    data => {
                        this.busyProvider.hideBusyIndicator();
                        let filename = "Report_Activities_" + this.userContext.userId + "_" + from + "_" + to + ".xlsx";
                        this.download(data, filename);
                    },
                    error => {
                        this.busyProvider.hideBusyIndicator();
                        // nei report ci si aspetta un blob pertanto gli eventuali errori in json
                        // non vengono correttamente mappati, pertanto non si utilizza la funzione
                        // generica handleError ma si visualizza l'errore così com'è.
                        this.messageProvider.notifyError(error);
                    });
        }
        // report dettagliato delle attività raggruppate per data
        else {
            this.activityService.reportActivities(this.userContext.srmToken, this.reportFromDate, this.reportToDate).
                subscribe(
                    data => {
                        this.busyProvider.hideBusyIndicator();
                        let filename = "Report_Activities_Dettagliato_" + this.userContext.userId + "_" + from + "_" + to + ".xlsx";
                        this.download(data, filename);
                    },
                    error => {
                        this.busyProvider.hideBusyIndicator();
                        // nei report ci si aspetta un blob pertanto gli eventuali errori in json
                        // non vengono correttamente mappati, pertanto non si utilizza la funzione
                        // generica handleError ma si visualizza l'errore così com'è.
                        this.messageProvider.notifyError(error);
                    });
        }
    }

    exportReportAdmin() {

        this.busyProvider.showBusyIndicator();
        this.messageProvider.clearAll();

        const parameters = new Object();
        parameters['from'] = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
        parameters['to'] = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');

        let usersFilter = null;
        for (let user of this.usersSelected) {
            if (usersFilter == null) {
                usersFilter = user.value;
            } else {
                usersFilter += ',' + user.value;
            }
        }
        if (usersFilter) {
            parameters['userIds'] = usersFilter;
        }

        let tasksFilter = null;
        for (let task of this.tasksSelected) {
            if (tasksFilter == null) {
                tasksFilter = task.value;
            } else {
                tasksFilter += ',' + task.value;
            }
        }
        if (tasksFilter) {
            parameters['taskIds'] = tasksFilter;
        }

        this.reportService.exportReport(this.userContext.srmToken, 'com.netsitech.srm.excel.generator.ActivitiesDetailedReportGenerator', parameters).
            subscribe(
                data => {
                    this.busyProvider.hideBusyIndicator();
                    let filename = "Report_Activities_Dettagliato_" + new Date().getTime() + ".xlsx";
                    this.download(data, filename);
                },
                error => {
                    this.busyProvider.hideBusyIndicator();
                    // nei report ci si aspetta un blob pertanto gli eventuali errori in json
                    // non vengono correttamente mappati, pertanto non si utilizza la funzione
                    // generica handleError ma si visualizza l'errore così com'è.
                    this.messageProvider.notifyError(error);
                });
    }

    private download(data: any, filename: string) {
        let blob = new Blob([data], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, filename);
    }

    filterUtentiGruppi (){
        
        this.utentiVisibili = [];
        if (this.selectedGruppo==0){
            this.utentiVisibili=this.managedUsers;
        }
        else{
            const usernames = this.userInfo.managedUsersMap[this.getGruppo(this.selectedGruppo)];
            
        if (Array.isArray(usernames)) {
            for (let username of usernames) {
                const user = this.filterUsernames.find(u => 
                    u.label.toLowerCase().includes(username.toLowerCase()) 
                );
                if (user) {
                    let item=this.filterUsers.find(u => 
                        u.value == user.value)
                    this.utentiVisibili.push({ label: item.label, value: item.value });
                }
        }
        }

    }}

    getGruppoUser(utente: User): string | null {
        if (!this.userInfo || !this.userInfo.managedUsersMap) return null;
        
        const managedUsersMap = this.userInfo.managedUsersMap;
        
        for (const key in managedUsersMap) {
            if (Object.prototype.hasOwnProperty.call(managedUsersMap, key)) {
                const value = managedUsersMap[key];
                if (Array.isArray(value) && value.some(v => v.toLowerCase() === utente.username.toLowerCase())) {
                    return key;
                }
            }
        }
        return null;
    }
    
    
    

}



// WEBPACK FOOTER //
// ./src/app/activities/activities.component.ts